import styled from "styled-components";
import { StyledPageProps } from "./PageSection.types";

export const StyledPage = styled.div<StyledPageProps>`
	margin: 0 auto;

	${(props) => {
		if (!props.fullWidth) {
			const pageSectionTheme = props.theme.components.pageSection;
			const margin = pageSectionTheme.margins[props.viewport.currentSize];
			return {
				padding: `0 ${margin}`,
				maxWidth: `${pageSectionTheme.maxWidth}`,
			};
		}
		return undefined;
	}}
`;
